import styled, { css } from 'styled-components';
import { DynamicExteriorImagePreviewTemplate } from './DynamicExteriorImagePreviewTemplate';
import { rem } from 'polished';
import { breakpoints } from '../../styles/theme';

export const DynamicExteriorImagePreviewStyled = styled(DynamicExteriorImagePreviewTemplate)`
    position: relative;
    width: 100%;
    height: 100%;
    max-width: ${rem(1050)};
    max-height: ${rem(600)};

    &.withoutMaxWidth {
        max-width: unset !important;
    }

    &.isBasket {
        @media (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg}px) {
            max-height: ${rem(200)};
        }

        @media (min-width: ${breakpoints.lg}px) {
            margin: 5%;
        }
    }

    @media (max-width: ${breakpoints.md}px) {
        max-width: ${rem(550)};
        margin: 0;
    }

    @media (max-width: ${breakpoints.sm}px) {
        max-width: unset;
    }

    img {
        object-fit: cover;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;

        &.withoutCover {
            object-fit: unset;
        }
    }

    ${({ minHeight }) =>
        minHeight &&
        css`
            min-height: ${rem(minHeight)};
        `}
`;
